import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-email-unsubscribe',
  templateUrl: './email-unsubscribe.component.html',
  styleUrls: ['./email-unsubscribe.component.css']
})
export class EmailUnsubscribeComponent implements OnInit {
  userProfileReferenceId;
  userEmail;
  response: boolean = false;
  responsemessage;
  isSuccessMsg: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _userService: UserService,
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.userProfileReferenceId = params.get('userReferenceId');
    });
    this.route.paramMap.subscribe(params => {
      this.userEmail = params.get('userEmail');
    });
  }
  UnsubscribeEmail() {
    this.isSuccessMsg = true;
    this._userService.EmailUnsubscribe(this.userProfileReferenceId, this.userEmail).subscribe((data: any) => {
      if (data == true) {
        this.response = true;
        this.responsemessage = "You have been successfully unsubscribed from receiving future emails from D-VMS. You may resubscribe anytime from your D-VMS user profile. "
      }
      else{
        this.response=false;       
        this.responsemessage="Your profile is not valid to unsubscribe email";
      }
    });
  }
  onCancel() {
    this.router.navigate(['/login']);
  }

  onSuccessPopUp() {
    this.isSuccessMsg = true;
  }

}
